import { connect } from 'react-redux';
import { compose } from 'redux';
import moment from 'moment';

import AddPatient from 'components/AddPatient';
import withPageLoader from 'components/withPageLoader';

import { createPatient } from 'store/actionCreators/patient';
import { requestAllPractitioners } from 'store/actionCreators/organization';
import { getAllPractionersRequstArgs } from 'store/selectors/user';
import { getPractitionersLoading } from 'store/selectors/organization';

const mapDispatchToProps = dispatch => {
  const initTime = moment.now();
  return { onSubmit: () => dispatch(createPatient({ initTime })) };
};

export default compose(
  withPageLoader({
    loadingSelector: getPractitionersLoading,
    initialActionArgsSelector: getAllPractionersRequstArgs,
    initialAction: requestAllPractitioners,
  }),
  connect(
    undefined,
    mapDispatchToProps,
  ),
)(AddPatient);
